import { Component, Input, signal } from '@angular/core';
import { Client } from 'src/app/core/entity/client';
import { Contact } from 'src/app/core/entity/contact';
import { ClientService } from 'src/app/core/services/clients.service';
import { ContactService } from 'src/app/core/services/contact.service';
import { TableColumn } from '../../../../table/interfaces/table-column';
import { getTranslationProvider } from 'src/app/core/i18n/getTranslationProvider';
import { TranslatableComponent } from 'src/app/core/i18n/TranslatableComponent';
import { Observable, switchMap } from 'rxjs';
import { translateColumnHeaders } from 'src/app/shared/components/table/misc/translate-column-header';

@Component({
  selector: 'app-client-contacts',
  templateUrl: './client.contacts.component.html',
  providers: [ContactService, getTranslationProvider('ClientContactsComponent')],
})
export class ClientContactsComponent extends TranslatableComponent {
  columns$: Observable<TableColumn[]>;
  savingState = signal(false);

  private columns: TableColumn[] = [
    { field: 'label', header: 'contact' },
    { field: 'phone', header: 'phone' },
    { field: 'email', header: 'email' },
    { field: 'comment', header: 'comments' },
    { field: 'action', header: '', sortable: false, width: '40px' },
  ];

  private _client: Client;
  private _contactModel: Contact = new Contact();
  private _selectedContact: Contact = null;

  constructor(
    private contactService: ContactService,
    private clientService: ClientService,
  ) {
    super();
    this.columns$ = this.onTranslationChangeMapTo(translateColumnHeaders(this.columns));
  }

  @Input()
  set client(client: Client) {
    if (client) {
      this._client = client;
    }
    this._contactModel = new Contact();
  }

  get client() {
    return this._client;
  }

  get contactModel() {
    return this._contactModel;
  }

  get selectedContact() {
    return this._selectedContact;
  }

  get isContactFormValid() {
    return this.isFieldValid(this._contactModel.label);
  }

  private isFieldValid(field: string): boolean {
    return (field ?? '')?.trim() !== '';
  }

  saveContact() {
    this.savingState.set(true);
    this.contactService
      .saveContact(this._client.id, this._contactModel)
      .pipe(switchMap(() => this.loadExistingContacts()))
      .subscribe(this.getSubscriber());
  }

  unSelect() {
    this._selectedContact = null;
    this._contactModel = new Contact();
  }

  onRowSelect(event: { data: any }) {
    this._contactModel = JSON.parse(JSON.stringify(event.data));
  }

  deleteContact(id: number) {
    this.contactService
      .deleteContact(id)
      .pipe(switchMap(() => this.loadExistingContacts()))
      .subscribe(this.getSubscriber());
  }

  private loadExistingContacts() {
    return this.clientService.getClientById(this._client.id);
  }

  private getSubscriber() {
    return {
      next: (client: Client) => {
        this._client = client;
        this.unSelect();
        this.savingState.set(false);
      },
      error: () => {
        this.savingState.set(false);
      },
    };
  }
}
